module.exports = __webpack_public_path__ + "img/spins_600.35deb092.png";